import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ExportHalfYearlyPDF = ({
  student,
  standardLabel,
  divisionLabel,
  marksData,
  maxMarksData,
  finYearLabel,
  criteriaResult,
}) => {
  const doc = new jsPDF("p", "mm", "a4");

  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("SHRADHANAND BAL MANDIR SENIOR SECONDARY SCHOOL", 105, 15, {
    align: "center",
  });

  doc.setFontSize(12);
  doc.text("Kamre, Ratu Road, Ranchi (Jharkhand) - 835222", 105, 20, {
    align: "center",
  });
  doc.text(
    "Affliated to CBSE, New Delhi(Affliation Number - 3430132, School No. - 66328)",
    105,
    25,
    {
      align: "center",
    },
  );

  doc.line(10, 28, 200, 28);

  doc.setFontSize(18);
  doc.text("PROGRESS REPORT", 105, 35, { align: "center" });

  doc.setFontSize(15);
  doc.text(`Half Yearly Examination ${finYearLabel}`, 105, 40, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.text(`Student Name : ${student?.name || ""}`, 14, 55);
  doc.text(`Class / Section : ${standardLabel} ${divisionLabel}`, 14, 65);
  doc.text(`Admission Number : ${student?.admission || ""}`, 14, 75);
  doc.text(`Roll No : ${student?.roll || ""}`, 140, 75);

  const marksHead = [
    [
      { content: "", colSpan: 3 },
      {
        content: "Internal Assessment",
        colSpan: 5,
        styles: { halign: "center" },
      },
      { content: "Half Yearly", colSpan: 3, styles: { halign: "center" } },
    ],
    [
      "Subject",
      "PT-1",
      "PT-2",
      "Class Work",
      "Home Work",
      "Sub Enrichment",
      "Discipline",
      "Class Involvement",
      "Theory",
      "Marks Obtained",
      "Grade",
    ],
    [
      "",
      maxMarksData.PT1,
      maxMarksData.PT2,
      maxMarksData.IA / 5,
      maxMarksData.IA / 5,
      maxMarksData.IA / 5,
      maxMarksData.IA / 5,
      maxMarksData.IA / 5,
      maxMarksData.HY,
      "",
      "",
    ],
  ];

  const marksBody = marksData.map((row) => [
    row.subjectName,
    row.pt1,
    row.pt2,
    row.classWork,
    row.homeWork,
    row.subEnrichment,
    row.discipline,
    row.classInvolvement,
    maxMarksData.HY,
    row.halfYearly,
    row.grade,
  ]);

  const totalHalfYearly = marksData.reduce(
    (sum, row) => sum + (Number(row.halfYearly) || 0),
    0,
  );

  marksBody.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "TOTAL",
    totalHalfYearly,
    "",
  ]);

  const percentage =
    marksData.length > 0
      ? (totalHalfYearly / (marksData.length * maxMarksData.HY)) * 100
      : 0;

  marksBody.push([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "PERCENTAGE",
    `${percentage.toFixed(2)}%`,
    "",
  ]);

  autoTable(doc, {
    head: marksHead,
    body: marksBody,
    startY: 80,
    theme: "grid",
    margin: { left: 10, right: 10 },
    styles: { fontSize: 9, halign: "center", lineWidth: 0.1, lineColor: 0 },
    columnStyles: { 0: { halign: "left" } },
  });

  doc.setFontSize(10);

  const afterMarksY = doc.lastAutoTable.finalY + 20;

  const gradeHead = [
    [
      { content: "Grade Subject" },
      {
        content: "Grade",
      },
    ],
  ];

  const gradeBody = criteriaResult.map((row) => [row.criteria, row.grade]);

  autoTable(doc, {
    head: gradeHead,
    body: gradeBody,
    startY: afterMarksY,
    theme: "grid",
    styles: { fontSize: 9, halign: "left" },
    columnStyles: {
      0: { cellWidth: 30 }, // Grade Subject
      1: { cellWidth: 15 }, // Grade
    },
  });

  const gradeTableTopY = afterMarksY;
  const gradeTableBottomY = doc.lastAutoTable.finalY;
  const gradeTableHeight = gradeTableBottomY - gradeTableTopY;

  const pageWidth = 210;
  const leftMargin = 14;
  const gradeTableWidth = 45;
  const gap = 6;

  const remarksX = leftMargin + gradeTableWidth + gap;
  const remarksWidth = pageWidth - remarksX - leftMargin;

  doc.rect(remarksX, gradeTableTopY, remarksWidth, gradeTableHeight);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);

  doc.text("Class Teacher's Remarks:", remarksX + 1, gradeTableTopY + 5);

  const finalY = gradeTableBottomY + 20;

  doc.text("Parents Sign", 14, finalY);
  doc.text("Class Teacher Sign", 50, finalY);
  doc.text("Principal Sign", 150, finalY);

  doc.save(`${student?.name || "Student"}_Half_Yearly_Report.pdf`);
};

export default ExportHalfYearlyPDF;
